import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  /** Optional element rendered at the right of the title row (e.g. an edit action). */
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, action }: SectionHeadingProps) {
  const titleEl = (
    <Typography
      sx={{
        // When an action is present the wrapping row owns the bottom margin.
        mb: action ? 0 : subtitle ? 0.5 : 2,
        fontWeight: 500,
        fontSize: 17,
        color: 'text.primary',
        letterSpacing: '-0.4px',
      }}
    >
      {title}
    </Typography>
  );

  return (
    <>
      {action ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            mb: subtitle ? 0.5 : 2,
          }}
        >
          {titleEl}
          {action}
        </Box>
      ) : (
        titleEl
      )}
      {subtitle && (
        <Typography sx={{ mb: 2, fontSize: 13, color: 'text.secondary' }}>
          {subtitle}
        </Typography>
      )}
    </>
  );
}
